import React from 'react';
import {IconIllustration, StyledGrid} from 'presentation/components';
import {Button, Stack, Typography} from '@mui/material';
import {translations} from 'presentation/translations-new';
import Icon from 'presentation/icons';
import {ErrorStateProps} from './types';

const {errorState} = translations['pt-br'].privateFlow.guideFlow.favoriteDoctors;

const ErrorState = ({isMobile, refetch}: ErrorStateProps) => {
	return (
		<StyledGrid.Root
			p={isMobile ? 2 : 4}
			alignContent="flex-start"
			justifyContent="center"
			height="100%">
			<StyledGrid.Item key={0} sm={12} md={12} lg={8}>
				<Stack gap={2} alignItems="center" p={3}>
					<IconIllustration variant="info" customIconName="info-filled" />
					<Typography variant="h6" color="textPrimary">
						{errorState.title}
					</Typography>
					<Typography variant="body1" textAlign="center" color="textSecondary">
						{errorState.description}
					</Typography>
					<Button
						variant="outlined"
						color="primary"
						endIcon={<Icon name="reload" />}
						onClick={refetch}>
						{errorState.buttonLabel}
					</Button>
				</Stack>
			</StyledGrid.Item>
		</StyledGrid.Root>
	);
};

export {ErrorState};
